import CategoryIcon from '@mui/icons-material/Category';

import ActivityCategories from "./ActivityCategoriesPage";

const exports = {
    Page: ActivityCategories,
    Icon: CategoryIcon
};
export default exports;
